<mat-dialog-content xmlns="http://www.w3.org/1999/html">
  <h2>
    {{ title }}
    <mat-divider></mat-divider>
  </h2>
  <mat-card-content>
    <p class="dialog-text">{{text}}</p>
    <div class="dialog-text">
      <div class="list-item">
        <mat-icon>{{iconList}}</mat-icon>
        <p [innerHTML]="textYes"></p>
      </div>

      <div class="list-item">
        <mat-icon>{{iconList}}</mat-icon>
        <p><strong>No: </strong>{{textNo}}</p>
      </div>

      <div class="list-item">
        <mat-icon>{{iconList}}</mat-icon>
        <p><strong>Cancel: </strong>{{textCancel}}</p>
      </div>
    </div>
    <div class="align-right" style="padding-bottom: 16px">
      <button mat-raised-button (click)="closeDialog()" type="button">
        <span>Cancel</span>
      </button>
      <button mat-raised-button (click)="confirm()" color="primary" type="button">
        <span>No</span>
      </button>
      <button mat-raised-button (click)="confirm(true)" color="primary" type="button">
        <span>Yes</span>
      </button>
    </div>
  </mat-card-content>
</mat-dialog-content>
